import useGlobalModal from 'shared/global-modal/libs/useGlobalModal'

import { useParams } from 'react-router-dom'

import ResetPassword from 'modules/AccessManage/components/ResetPassword'
import { keyAccessFields } from 'modules/AccessManage/components/UserKeyAccess/keyAccessFields'
import { User } from 'modules/AccessManage/types'
import UserKeyAccessWrapper from 'modules/AccessManage/ui/UserKeyAccessWrapper'

import { Button } from 'shared/ui/Button'
import FormItems from 'shared/ui/Form/FormItems'
import ListInfo from 'shared/ui/ListInfo'
import SkeletonNode from 'shared/ui/SkeletonNode'
import Switch from 'shared/ui/Switch'

import ChangeIsBlockedUser from '../ChangeIsBlockedUser'

const labelClassname = 'w-[160px] leading-[24px] text-[16px] text-light_gray_4'
const valueClassname = 'leading-[24px] text-[16px] text-dark'

interface Props {
  userInfo: User | null
  mode: 'view' | 'edit'
  isFetching: boolean
}
const UserKeyAccess = ({ userInfo, mode, isFetching }: Props) => {
  const { userId } = useParams()
  const { openModal } = useGlobalModal()

  const onChangeSwitch = (value: boolean) => {
    openModal({
      body: (
        <ChangeIsBlockedUser
          value={value}
          userId={userId}
        />
      ),
      withPadding: false,
    })
  }

  const onChangePassword = () => {
    openModal({
      body: <ResetPassword userId={userId} />,
      withPadding: false,
    })
  }

  return (
    <UserKeyAccessWrapper title="Ключ доступа">
      <div className="px-[24px] pb-[20px] border-b border-b-light_gray_3">
        {mode === 'view' ? (
          <ListInfo
            className="mt-[12px]"
            gap={0}
          >
            <li className="!justify-start py-[8px]">
              <span className={labelClassname}>Логин</span>
              <SkeletonNode
                loading={isFetching}
                className="!h-6 !w-full !max-w-[200px]"
              >
                <span className={valueClassname}>{userInfo?.email || '-'}</span>
              </SkeletonNode>
            </li>
          </ListInfo>
        ) : (
          <div className="mt-[12px] flex flex-col gap-[16px]">
            <FormItems items={keyAccessFields} />
          </div>
        )}
        <Button
          onClick={onChangePassword}
          className="h-auto mt-[22px] p-0 leading-[24px] font-semibold text-[16px] text-blue border-0 shadow-none"
        >
          Сбросить пароль
        </Button>
      </div>
      <div className="flex items-center justify-between px-[24px] pt-[24px]">
        <div className="flex flex-col gap-[5px]">
          <strong className="leading-[24px] font-bold text-[16px] text-gray">
            {userInfo?.is_blocked
              ? 'Разблокировать пользователя'
              : 'Заблокировать пользователя'}
          </strong>
          <span className="leading-[20px] text-[14px] text-light_gray_4">
            {userInfo?.is_blocked
              ? 'Пользователь получит доступ к системе ЛОГО'
              : 'Пользователь потеряет доступ к системе ЛОГО'}
          </span>
        </div>
        <Switch
          value={userInfo?.is_blocked}
          onChange={onChangeSwitch}
        />
      </div>
    </UserKeyAccessWrapper>
  )
}

export default UserKeyAccess
